module.exports = __webpack_public_path__ + "static/media/M.75cd8337.jpg";